import { RouteIds } from '@/app/plugins/vue/RouteIds';
import { Source } from '@/app/system/guest/Source';
import { configEnv } from '@/shared/config-env';
import {
  createRouter,
  createWebHistory,
} from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'Profile',
    component: () => import(/* webpackChunkName: "profile" */ '@/shared/components/TheProfile/TheProfile.vue'),
    isInNavbar: true,
    title: 'header.profile',
    isAllowWithoutUserCard: true,
  },
  {
    path: '/invites',
    name: 'Invites',
    component: () => import(/* webpackChunkName: "invites" */ '@/shared/components/TheFriends/TheFriends.vue'),
    isInNavbar: false,
    title: 'header.invite',
    isAllowWithoutUserCard: false,
  },
  {
    path: '/catalog',
    name: 'Catalog',
    component: () => import(/* webpackChunkName: "catalog" */ '@/shared/components/TheCatalog/TheCatalogRouterView.vue'),
    isInNavbar: true,
    title: 'header.catalog',
    isAllowWithoutUserCard: false,
    redirect: { name: 'Products' },
    children: [
      {
        path: 'products',
        name: 'Products',
        component: () => import(/* webpackChunkName: "products" */ '@/shared/components/TheCatalog/TheCatalogProducts.vue'),
        isAllowWithoutUserCard: false,
        meta: { transition: 'none' },
      },
      {
        path: 'services',
        name: 'Services',
        component: () => import(/* webpackChunkName: "services" */ '@/shared/components/TheCatalog/TheCatalogServices.vue'),
        isAllowWithoutUserCard: false,
        meta: { transition: 'none' },
      },
    ],
  },
  {
    path: '/orders',
    name: 'Orders',
    component: () => import(/* webpackChunkName: "orders" */ '@/shared/components/TheOrders/TheOrdersV2.vue'),
    isInNavbar: true,
    title: 'header.orders',
    isAllowWithoutUserCard: false,
    props() {
      return {
        idSource: new Source([]),
      };
    },
  },
  {
    path: '/orders/:id',
    name: 'OrdersSpecific',
    component: () => import(/* webpackChunkName: "orders-of-id" */ '@/shared/views/TheOrdersList.vue'),
    isInNavbar: false,
    title: null,
    isAllowWithoutUserCard: false,
    props() {
      return {
        idSource: new RouteIds(),
      };
    },
  },
  {
    path: '/catalog/:id',
    name: 'Product',
    component: () => import(/* webpackChunkName: "catalogDetail" */ '@/shared/components/TheProduct/TheProduct.vue'),
    isInNavbar: false,
    title: null,
    isAllowWithoutUserCard: false,
  },
  {
    path: '/rating',
    name: 'Rating',
    component: () => import(/* webpackChunkName: "rating" */ '@/shared/components/TheRating/TheRating.vue'),
    isInNavbar: true,
    title: 'header.rating',
    isAllowWithoutUserCard: false,
  },
  {
    path: '/no-card',
    name: 'NoCard',
    component: () => import(/* webpackChunkName: "nocard" */ '@/shared/views/TheNoCard/TheNoCard.vue'),
    isInNavbar: false,
    title: null,
    isAllowWithoutUserCard: true,
  },
  {
    path: '/get-card',
    name: 'GetCard',
    component: () => import(/* webpackChunkName: "getcard" */ '@/shared/components/TheGetCard/TheGetCard.vue'),
    isInNavbar: false,
    title: null,
    isAllowWithoutUserCard: true,
  },
  {
    path: '/invite',
    name: 'InviteForm',
    component: () => import(/* webpackChunkName: "invite" */ '@/shared/components/TheInvite/TheInvite.vue'),
    isInNavbar: false,
    title: null,
    isAllowWithoutUserCard: true,
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import(/* webpackChunkName: "faq" */ '@/shared/components/TheFaq/TheFaq.vue'),
    isInNavbar: true,
    title: 'header.faq',
    isAllowWithoutUserCard: true,
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import(/* webpackChunkName: "faq" */ '@/shared/components/TheSupport/TheSupport.vue'),
    isInNavbar: true,
    title: 'header.support',
    isAllowWithoutUserCard: true,
  },
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "not-found" */ '@/projects/synergy/pages/TheNotFound.vue'),
  },
];

if (configEnv.VUE_APP_ENVIRONMENT === 'development') {
  routes.push(require('@/shared/lib/uikit/routingRules').default);
}

const router = createRouter({
  'history': createWebHistory('/my'),
  routes,
});

export default router;
